module.exports = __webpack_public_path__ + "img/9788954430999.235f7116.jpg";